import { TAddDeviceGroupFields, TAddDeviceGroupResponse } from 'shared/types'
import { api } from '..'

export const createDeviceGroup = (data: TAddDeviceGroupFields) =>
  api
    .post<TAddDeviceGroupResponse>('/v1/device-group', data)
    .then(({ data }) => data)

export const deleteDeviceGroup = (deviceGroupId: string) => () =>
  api.delete(`/v1/device-group/${deviceGroupId}`)
